<template>
  <div class="drive" id="benefits">
    <div class="container">
      <div class="drive__wrapper">
        <p class="drive__title">Driving Growth Through Smart Marketing</p>
        <p class="drive__text">Unlock your brand’s full potential with strategies rooted in creativity, data, and innovation.</p>
        <div class="drive__block">
          <div class="drive__left">
            <div class="drive__item">
              <img src="@images/driveImage1.png" alt="image">
              <div class="drive__item-inner">
                <p class="drive__item-title">Integrated Strategic Planning</p>
                <p class="drive__item-text">We design strategies that align all marketing channels, building a consistent, powerful brand presence across every platform.</p>
              </div>
            </div>
            <div class="drive__item">
              <img src="@images/driveImage2.png" alt="image">
              <div class="drive__item-inner">
                <p class="drive__item-title">Custom-Tailored Solutions</p>
                <p class="drive__item-text">Every strategy is adapted to your specific business needs — no generic templates, only personalized growth plans.</p>
              </div>
            </div>
          </div>
          <div class="drive__right">
            <div class="drive__item">
              <img src="@images/driveImage3.png" alt="image">
              <div class="drive__item-inner">
                <p class="drive__item-title">Innovative Creative Approach</p>
                <p class="drive__item-text">Our team brings fresh ideas to every project, crafting campaigns that grab attention and position your brand ahead of the competition.</p>
              </div>
            </div>
            <div class="drive__item">
              <img src="@images/driveImage4.png" alt="image">
              <div class="drive__item-inner">
                <p class="drive__item-title">Insight-Driven Marketing</p>
                <p class="drive__item-text">We turn data into actionable insights, optimizing every campaign based on real analytics to maximize efficiency, engagement, and returns.</p>
              </div>
            </div>
            <div class="drive__item">
              <img src="@images/driveImage5.png" alt="image">
              <div class="drive__item-inner">
                <p class="drive__item-title">Cutting-Edge Technologies</p>
                <p class="drive__item-text">We stay at the forefront of marketing innovation, using top-tier tools for automation, analytics, SEO, and social media to deliver superior results.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.drive {
  padding-block: 125px 150px;

  &__title {
    color: #2F327D;
    text-align: center;
    font-family: "Nunito Sans", sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 180%;
  }

  &__text {
    color: #696984;
    text-align: center;
    font-family: "Nunito Sans", sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 180%;
  }

  &__block {
    margin-top: 50px;
    display: flex;
    align-items: flex-start;
    gap: 60px
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: 40px;

    & img {
      width: 100%;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  &__right .drive__item {
    flex-direction: row;
    width: fit-content;
  }

  &__item {
    width: 459px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;

    &-inner {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &-title {
      color: #252641;
      font-size: 22px;
      font-weight: 500;
      line-height: 180%;
    }

    &-text {
      color: #696984;
      font-size: 18px;
      font-weight: 400;
      line-height: 180%;
      letter-spacing: 0.36px;
    }
  }
}

@media (max-width: 1300px) {
  .drive {
    &__block {
      flex-direction: column;
      align-items: center;
    }
  }
}

@media (max-width: 650px) {
  .drive {
    &__item {
      width: 100%;
      flex-direction: column !important;
      align-items: center;

      &-title {
        text-align: center;
        font-size: 16px;
        line-height: 20px;
      }

      &-text {
        text-align: center;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
}
</style>